import { render, staticRenderFns } from "./ticketInfo-new.vue?vue&type=template&id=60d4518a&scoped=true"
import script from "./ticketInfo-new.vue?vue&type=script&lang=js"
export * from "./ticketInfo-new.vue?vue&type=script&lang=js"
import style0 from "./ticketInfo-new.vue?vue&type=style&index=0&id=60d4518a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4518a",
  null
  
)

export default component.exports